import { requestGet, requestPost } from '@/utils/request'

export function login(params){
  return requestPost('/login', params);
}
export function logout(params){
  return requestPost('/logout', params);
}

export function getInfo(){
  return requestGet('/getInfo');
}
